import * as React from "react";
import IndividualJournalEntryTimelineCard from "../../../../components/shared/individualHistoryPanel/individualJournalEntryTimelineCard/individualJournalEntryTimelineCard";
import { UserClaimsService } from "../../../../services/currentUserService/currentUserService";
import { Box } from "@mui/material";
import JournalEntryDrawer from "../../../../components/common/jouralEntryDrawer/journalEntryDrawer";
import useLogAccessEvent from "../../../../hooks/useLogAccessEvent";
import { AccessEventOFCReducedDetails } from "../../../../services/types/accessEventTypes";

export interface PayrollNotesProps {
    sessionId: string;
    payrollKey: string;
    projectCode: string;
}

const PayrollNotes: React.FC<PayrollNotesProps> = (props) => {
    const claimservice = new UserClaimsService();
    const { logEvent } = useLogAccessEvent();

    const [journalKey, setJournalKey] = React.useState<number>(0);
    const [open, setOpen] = React.useState<boolean>(false);

    let email = claimservice.GetCurrentUserEmail();
    let imKey = claimservice.GetCurrentResourceId();

    let catData = { userId: String(imKey), email: email, payrollKey: String(props.payrollKey) };

    const handleSave = () => {
        const evtData: AccessEventOFCReducedDetails = {
            sessionID: props.sessionId,
            projectCode: props.projectCode,
        };
        logEvent("PayrollNoteAdded", evtData);
        setOpen(false);
    };

    return (
        <Box sx={{ width: 1, height: 1, m: 1 }}>

            {open && 
                <JournalEntryDrawer 
                    journalCategory={6} 
                    journalCategoryData={[JSON.stringify(catData)]} 
                    journalHistory={[]} 
                    open={open} 
                    notes
                    onClose={() => setOpen(false)} 
                    onSave={handleSave} 
                    onSaveError={()=> setOpen(false)}          
                />
            }
            {props.payrollKey && (
                <IndividualJournalEntryTimelineCard 
                    emailAddress={email} 
                    imKey={imKey}
                    key={journalKey}
                    payrollKey={props.payrollKey}
                    onCreateJournalEntry={() => setOpen(true)}
                    note
                    payroll
                    onlyIncludePayrollEntries
                />
            )}
        </Box>
    );
};

export default PayrollNotes;
